//import React components
import PropTypes from "prop-types";
import {Button} from "reactstrap";

//import components


//import icons
import MenuIcon from "@mui/icons-material/Menu";

//Props settings for MenuButton
MenuButton.propTypes = {
    state: PropTypes.array,
}

MenuButton.defaultProps = {

}


export default function MenuButton({state}) {
    const [openState, setOpenState] = state;

    function toggleMenu() {
        setOpenState(!openState);
    }

    return (
        <>
            <Button
                title={openState ? "Minimer sidemeny" : "Åpne sidemeny"}
                color={"blank"}
                className={"nav-menuBtn"}
                onClick={toggleMenu}
            >
                {/*<ArrowBackOutlinedIcon className={"menuBtn-extend menuBtn-opener"}/>*/}
                <MenuIcon/>
                {/*<ArrowForwardOutlinedIcon className={"menuBtn-minimize menuBtn-opener"}/>*/}
            </Button>
        </>
    )
}
